import { createSelector } from 'reselect';

export const selectRouter = state => state.router;

export const selectLocation = () =>
  createSelector(
    selectRouter,
    router => router.location,
  );
